export function getActionName(actionPrefix: string, actionName: string) {
    return `${actionPrefix}/${actionName}`;
}